// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/source/resources/source_artifact.proto (package gx.source.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_services_database_models_public } from "../../database/models/public_pb.js";

/**
 * Describes the file services/source/resources/source_artifact.proto.
 */
export const file_services_source_resources_source_artifact = /*@__PURE__*/
  fileDesc("Ci9zZXJ2aWNlcy9zb3VyY2UvcmVzb3VyY2VzL3NvdXJjZV9hcnRpZmFjdC5wcm90bxITZ3guc291cmNlLnJlc291cmNlcyK5AgoWU291cmNlQXJ0aWZhY3RSZXNvdXJjZRIKCgJpZBgBIAEoCRIRCgl0ZW5hbnRfaWQYAiABKAkSEQoJc291cmNlX2lkGAMgASgJEhYKDnNvdXJjZV9zeW5jX2lkGAQgASgJEi4KCmNyZWF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEkMKDGNvbnRlbnRfdHlwZRgGIAEoDjItLmd4LmRhdGFiYXNlLm1vZGVscy5Tb3VyY2VBcnRpZmFjdENvbnRlbnRUeXBlEjQKBHR5cGUYByABKA4yJi5neC5kYXRhYmFzZS5tb2RlbHMuU291cmNlQXJ0aWZhY3RUeXBlEhoKEm9iamVjdF9zdG9yYWdlX3VyaRgIIAEoCRIOCgZzaGEyNTYYCSABKAlC4wEKF2NvbS5neC5zb3VyY2UucmVzb3VyY2VzQhNTb3VyY2VBcnRpZmFjdFByb3RvUAFaRWdpdGh1Yi5jb20vZ2FsYXh5LWlvL2d4L3NoYXJlZC9nby9jb250cmFjdHMvc2VydmljZXMvc291cmNlL3Jlc291cmNlc6ICA0dTUqoCE0d4LlNvdXJjZS5SZXNvdXJjZXPKAhNHeFxTb3VyY2VcUmVzb3VyY2Vz4gIfR3hcU291cmNlXFJlc291cmNlc1xHUEJNZXRhZGF0YeoCFUd4OjpTb3VyY2U6OlJlc291cmNlc2IGcHJvdG8z", [file_google_protobuf_timestamp, file_services_database_models_public]);

/**
 * Describes the message gx.source.resources.SourceArtifactResource.
 * Use `create(SourceArtifactResourceSchema)` to create a new message.
 */
export const SourceArtifactResourceSchema = /*@__PURE__*/
  messageDesc(file_services_source_resources_source_artifact, 0);

